import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './SharedPaginationPageItem.scss';

function SharedPaginationPageItem({ children, href, isSelected, onClick, dataTn }) {
    return isSelected ? (
        <span className={classnames(styles.item, styles.isSelected)} data-tn={dataTn}>
            {children}
        </span>
    ) : (
        <a href={href} className={styles.item} onClick={onClick} data-tn={dataTn}>
            {children}
        </a>
    );
}

SharedPaginationPageItem.propTypes = {
    children: PropTypes.node.isRequired,
    href: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    dataTn: PropTypes.string,
};

export { SharedPaginationPageItem };
